// extracted by mini-css-extract-plugin
export default {"description":"style_description__gP0Zr","fade-in":"style_fade-in__orSd1","top":"style_top__e2k7S","image":"style_image__Rjr2K"};